module.exports = __webpack_public_path__ + "assets/images/JMD500.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMD500.png
// module id = 1388
// module chunks = 1